import { Component, Input } from '@angular/core';
import { HistoryModel } from '@evorait/pace-core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import EquipmentHistoryModel from './equipment-history.model';

@Component({
    selector: 'pace-equipment-history',
    templateUrl: './equipment-history.component.html',
    styleUrls: ['./equipment-history.component.scss'],
    standalone: false,
})
export class EquipmentHistoryComponent {
    @Input()
    public model: EquipmentHistoryModel;

    public orderBy = '';
    public reverse = false;
    public constructor(public readonly modalInstance: BsModalRef) {}

    public trackById(_index: number, entry: HistoryModel): number {
        return entry.id;
    }

    public setOrderBy(field: string): void {
        if (this.orderBy === field) {
            this.reverse = !this.reverse;
        } else {
            this.orderBy = field;
        }
    }
}
